import { Currency } from "@/serviceClients/userWebServices";

export const currencies: Currency[] = [
    { code: "USD", ratePerUsd: 1, symbol: "$", allowInPayout: true },
    { code: "EUR", ratePerUsd: 0.82, symbol: "€", allowInPayout: false },
    { code: "PLN", ratePerUsd: 3.73, symbol: "zł", allowInPayout: true },
];